import { Field } from './field';
import { User } from './user';
import { Device } from './device';
import { FarmCadastralSheet } from './farmCadastralSheet';
import { Company } from './company';
import { TenantGeneralData } from './tenantGeneralData';

export class Farm extends TenantGeneralData {
  id: number;
  agrirouterUUID: string;
  name: string;
  phone: string;
  country: string;
  countryCode: string;
  street1: string;
  street2: string;
  city: string;
  zipCode: string;
  lat: number;
  lng: number;
  asl: number;
  meteoLat: number;
  meteoLng: number;
  meteoAsl: number;
  meteoCity: string;
  meteoCountry: string;
  cooperative: string;
  agriculturalAssociation: string;
  producerOrganisation: string;
  associationCardNumber: string;
  fields: Array<Field>;
  users: Array<User>;
  sheets: Array<FarmCadastralSheet>;
  devices: Array<Device>;
  cuaa: string;
  company: Company;
  externalSourceOwnership: string;
  welcomeCheck: boolean;
  companyMission: string;
  size: number;
  fieldsSize?: number;
  preferredCountry: string;
  preferredProductsCountry: string;
  groups: Array<FarmGroup>;
  preferredCurrency: string;

  constructor() {
    super();
    this.name = null;
    this.phone = null;
    this.country = null;
    this.countryCode = null;
    this.street1 = null;
    this.street2 = null;
    this.city = null;
    this.zipCode = null;
    this.lat = null;
    this.lng = null;
    this.meteoLat = null;
    this.meteoLng = null;
    this.meteoAsl = null;
    this.meteoCity = null;
    this.meteoCountry = null;
    this.asl = null;
    this.fields = null;
    this.users = null;
    this.sheets = null;
    this.devices = null;
    this.cooperative = null;
    this.agriculturalAssociation = null;
    this.producerOrganisation = null;
    this.associationCardNumber = null;
    this.cuaa = null;
    this.company = null;
    this.externalSourceOwnership = null;
    this.welcomeCheck = null;
    this.companyMission = null;
    this.size = null;
    this.fieldsSize = null;
    this.preferredProductsCountry = null;
    this.preferredCurrency = null;
  }
}

export class FarmGroup {
  group: string;
  rolesInGroup: Array<any>;
  name?: string;
  imageUrl?: string;
}

/*
*********** MODELLO DI BACKEND **********************
package com.xfarm.api.v1.core

import com.xfarm.api.v1.auth.User
import com.xfarm.api.v1.map.FarmCadastralSheet
import com.xfarm.api.v1.xsense.Device

class Farm {
    name
    phone
    country
    street1
    street2
    city
    zipCode
    Double lat
    Double lng


    static hasMany = [users: User, fields: Field, sheets: FarmCadastralSheet,
                      devices: Device]

    static constraints = {
        name    blank: false
        phone   blank: false, nullable: true
        country blank: false, nullable: true
        street1 blank: false, nullable: true
        street2 blank: false, nullable: true
        city    blank: false, nullable: true
        zipCode blank: false, nullable: true
        lat     nullable: true
        lng     nullable: true
    }
}


*/
